import type { ITimeSeriesData } from '@quesmed/types/resolvers/query/admin';
import { useMemo } from 'react';
import { productToColor } from '@/config';
import type { ChartConfig } from '@/core/ui';
import { useAuthState } from '@/store/auth';
import { spaceReplacer } from '@/utils';

export const useChartData = (data: ITimeSeriesData[]) => {
  const { isSalesRole } = useAuthState();
  const chartData = useMemo(() => {
    const result = data ?? [];
    const chartConfig: ChartConfig = {};
    const seriesKey: keyof ITimeSeriesData = isSalesRole ? 'count' : 'value';

    const list = result.map((d) => {
      const obj = d.stats.reduce(
        (acc, { product, ...rest }) => {
          const label = spaceReplacer(product.name);
          acc[label] = rest[seriesKey];
          const color = productToColor[product.id] || 'red';
          chartConfig[label] = { label, color };
          return acc;
        },
        {} as Record<string, number>,
      );

      const total = d.stats.reduce((a, c) => a + c[seriesKey], 0);

      return {
        name: d.month.trim(),
        value: Math.ceil(Number(d[seriesKey])),
        count: Math.ceil(Number(d.count)),
        isCurrency: !isSalesRole,
        total,
        // fill: `var(--color-${d.month.trim()})}`,
        ...obj,
      };
    });
    // .sort((a, b) => a.value - b.value);

    return { list, chartConfig };
  }, [data]);

  return chartData;
};
